import { of as observableOf, from } from 'rxjs';
import { share, switchMap, catchError, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { UserTagAction } from './user-tag.action';
import { UserTagService } from '@toro/common/shared/services/users/user-tags.service';

@Injectable()
export class UserTagEffects {
  constructor(
    private actions$: Actions<UserTagAction>,
    private userTagService: UserTagService
  ) {}

  /** Verifica se o usuário possui assessor exclusivo */

  public getUserTag$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserTagAction.getUserTag),
      switchMap(() =>
        from(this.userTagService.get('v2/tags')).pipe(
          // Converte a Promise em Observable
          map((userTags) => ({
            type: UserTagAction.getUserTagSuccess,
            payload: userTags,
          })),
          catchError(({ message }) =>
            observableOf({
              type: UserTagAction.getUserTagError,
              payload: message,
            })
          )
        )
      ),
      share()
    )
  );
}
